import React from 'react';
import ProductCard from '../shop/ProductCard';
import { useProducts } from 'hooks/useProducts';

// Dos formatos:
//  - products: copia fija de productos (bloques armados en el editor).
//  - handles: lista de handles que se resuelven EN VIVO contra la tienda, así
//    el precio y la foto siempre son los actuales (artículos importados de WP).
export default function BlogProductsBlock({ data }) {
  const { products, handles, columns } = data;
  const { products: live } = useProducts();

  const list = handles?.length
    ? handles.map((h) => (live || []).find((p) => p.handle === h)).filter(Boolean)
    : products;
  if (!list || list.length === 0) return null;

  // Nº de columnas elegido en el editor (2 o 3). El CSS lo lee de la variable.
  const cols = columns || 2;

  return (
    <div className="blog-products-block">
      <div className="blog-products-grid" style={{ '--blog-products-cols': cols }}>
        {list.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </div>
  );
}
